import type { MailboxInfo } from "owa-client-types";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { ACCOUNT_CRITICAL_RESOURCE_AUTH_ACTION, getResourceTokenAuthInfoBarStore, type StoredResourceTokenAuthInfoBarRequest, } from "owa-account-authstate-store";

export function hasResourceTokenAuthInfoBarRequest(mailboxInfo: MailboxInfo): boolean {
    return !!getResourceTokenAuthInfoBarRequest(mailboxInfo);
}

export function getResourceTokenAuthInfoBarRequest(mailboxInfo: MailboxInfo): StoredResourceTokenAuthInfoBarRequest | undefined {
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        const accountMailboxInfo = mailboxInfo.accountsMailboxInfos.find(hasAccountCriticalResourceAuthInfoBarRequest);
        return accountMailboxInfo
            ? getResourceTokenAuthInfoBarRequest(accountMailboxInfo)
            : undefined;
    }
    
    const request = getResourceTokenAuthInfoBarStore(mailboxInfo)?.request;
    return request &&
        (request.action !== ACCOUNT_CRITICAL_RESOURCE_AUTH_ACTION ||
            hasAccountCriticalResourceAuthInfoBarRequest(mailboxInfo))
        ? request
        : undefined;
}

export function hasAccountCriticalResourceAuthInfoBarRequest(mailboxInfo: MailboxInfo): boolean {
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        return mailboxInfo.accountsMailboxInfos.some(hasAccountCriticalResourceAuthInfoBarRequest);
    }
    
    return (isAccountFeatureEnabled("auth-monarch-signin-banner", mailboxInfo, true /* dontThrowErrorIfNotInitialized */) &&
        getResourceTokenAuthInfoBarStore(mailboxInfo)?.request?.action ===
            ACCOUNT_CRITICAL_RESOURCE_AUTH_ACTION);
}
